import { DBFindOne, DBInsert, DBRemove, DBFind } from '@weblite/persist'
import { RoomLastScroll } from '$logic/room-last-scroll/types'

const COLLECTION = 'roomLastScroll'

interface DBRoomLastScroll extends RoomLastScroll {
  roomId: string
}

export const cachedRoomLastScrolls: { [roomId: string]: RoomLastScroll } = {}

export const roomLastScrollDBStorage = {
  delete(roomId: string) {
    return DBRemove(COLLECTION, roomId)
  },

  get(roomId: string): Promise<RoomLastScroll | undefined> {
    return DBFindOne(COLLECTION, roomId)
  },

  set(roomId: string, lastScroll: RoomLastScroll) {
    return DBInsert(COLLECTION, { ...lastScroll, roomId })
  },

  getAll(): Promise<DBRoomLastScroll[]> {
    return DBFind(COLLECTION)
  },
}
